(function (Drupal, once) {
  Drupal.behaviors.enableButtonOnRadio = {
    attach: function (context, settings) {
      const forms = once('enable-radio-check', '.webform-nerivio-questionnaire', context);

      forms.forEach((form) => {
        const radioInputs = form.querySelectorAll('.form-item__radio input[type="radio"]');
        const actionButton = form.querySelector('.webform-actions input[type="submit"]');

        const stepSelectors = [
          'edit-first-question',
          'edit-second-question',
          'edit-third-question',
          'edit-fourth-question'
        ];
        let currentStep = 0;
        let currentStepContainer = null;

        stepSelectors.forEach((selector, index) => {
          const stepContainer = form.querySelector(`[data-drupal-selector="${selector}"]`);
          if (stepContainer) {
            currentStep = index + 1;
            currentStepContainer = stepContainer;
          }
        });

        if (currentStep > 0 && currentStepContainer) {
          const labelEl = currentStepContainer.querySelector('.form-item__processed_text');
          if (labelEl) {
            let stepIndicator = labelEl.parentElement.querySelector('.wizard-step-indicator');
            if (!stepIndicator) {
              stepIndicator = document.createElement('div');
              stepIndicator.className = 'wizard-step-indicator';

              const currentSpan = document.createElement('span');
              currentSpan.className = 'step-current';
              stepIndicator.appendChild(currentSpan);

              const totalSpan = document.createElement('span');
              totalSpan.className = 'step-total';
              stepIndicator.appendChild(totalSpan);

              labelEl.insertAdjacentElement('beforebegin', stepIndicator);
            }

            stepIndicator.querySelector('.step-current').textContent = currentStep;
            stepIndicator.querySelector('.step-total').textContent = '/' + stepSelectors.length;

            stepIndicator.style.marginBottom = '1rem';
          }
        }

        if (!radioInputs.length || !actionButton) {
          return;
        }

        actionButton.disabled = true;
        actionButton.classList.remove('radio-selected');
        actionButton.classList.add('radio-not-selected');

        radioInputs.forEach((radio) => {
          radio.addEventListener('change', () => {
            const isChecked = Array.from(radioInputs).some((r) => r.checked);
            if (isChecked) {
              actionButton.disabled = false;
              actionButton.classList.add('radio-selected');
              actionButton.classList.remove('radio-not-selected');
            } else {
              actionButton.disabled = true;
              actionButton.classList.remove('radio-selected');
              actionButton.classList.add('radio-not-selected');
            }
          });
        });
      });
    },
  };
})(Drupal, once);
